import {Component, OnInit, ViewChild, ViewEncapsulation, ElementRef, AfterViewInit} from '@angular/core';
import 'rxjs/add/operator/filter';
import {state, style, transition, animate, trigger, AUTO_STYLE} from '@angular/animations';

import { MenuItems,StaffMenuItems,BRANCHmenuITEMS,Docmenuitems } from '../../shared/menu-items/menu-items';
import { PatternValidator,NgForm } from '@angular/forms';
import { Router } from '@angular/router';


export interface Options {
  heading?: string;
  removeFooter?: boolean;
  mapHeader?: boolean;
}

@Component({
  selector: 'app-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css'],
  encapsulation: ViewEncapsulation.None,

  animations: [
    trigger('mobileMenuTop', [
        state('no-block, void',
            style({
                overflow: 'hidden',
                height: '0px',
            })
        ),
        state('yes-block',
            style({
                height: AUTO_STYLE,
            })
        ),
        transition('no-block <=> yes-block', [
            animate('400ms ease-in-out')
        ])
    ])
  ]
})

export class AdminLayoutComponent implements OnInit {
  deviceType = 'desktop';
  verticalNavType = 'expanded';
  verticalEffect = 'shrink';
  innerHeight: string;
  isCollapsedMobile = 'no-block';
  isCollapsedSideBar = 'no-block';
  toggleOn = true;
  windowWidth: number;

  public htmlButton: string;
  public navmenuitems=[];

  usrdtls:any={};
  name:any;
  login:any={};

  constructor(public menuItems: MenuItems,public stafMenuItems:StaffMenuItems,public branchmenuitems:BRANCHmenuITEMS,public docmenuitems:Docmenuitems,private router: Router) {
    

    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + 'px';
    this.windowWidth = window.innerWidth;
    this.setMenuAttributs(this.windowWidth);

    // this.htmlButton = '<div class="fixed-button">';
    // this.htmlButton += '<a href="https://codedthemes.com/item/mash-able-pro-admin-template/" class="btn btn-primary" aria-hidden="true">';
    // this.htmlButton += 'Upgrade To Pro</a>';
    // this.htmlButton += '</div>';

  }
  @ViewChild('closeAddExpenseModal') closeAddExpenseModal: ElementRef;
  ngOnInit() {

//     var usrl=localStorage.getItem('usrl');
//     //console.log('authusid',usrl);

//    // alert(usrl);
//     if(usrl=="1")
//     {
//       this.navmenuitems=this.menuItems.getAll(); 
//     }
// else if(usrl=="2")
//     this.navmenuitems=this.stafMenuItems.getAll();
//   }
debugger
//  this.name=localStorage.getItem('usid').toString();
//  this.name=this.name.replace('"','');
//  this.name=this.name.replace('"','');
// //var nm=this.usrdtls.;
//var usrl=localStorage.getItem('Logtype');
var usrl='A';
//console.log('usrdtls',this.usrdtls);
//console.log('authusid',localStorage.getItem('name'));

// alert(usrl);

if(usrl=="A")
{
  this.navmenuitems=this.menuItems.getAll(); 
}
else if(usrl=="S")
{
this.navmenuitems=this.stafMenuItems.getAll();
}

else if(usrl=="B")
{
this.navmenuitems=this.branchmenuitems.getAll();
}

else if(usrl=="D")
{
this.navmenuitems=this.docmenuitems.getAll();
}
}
  onClickedOutside(e: Event) {
      if (this.windowWidth < 768 && this.toggleOn && this.verticalNavType !== 'offcanvas') {
          this.toggleOn = true;
          this.verticalNavType = 'offcanvas';
      }
  }

  onResize(event) {
    this.innerHeight = event.target.innerHeight + 'px';
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    let reSizeFlag = true;
    if (this.deviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.deviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
    }

    if (reSizeFlag) {
      this.setMenuAttributs(this.windowWidth);
    }
  }

  setMenuAttributs(windowWidth) {
      if (windowWidth >= 768 && windowWidth <= 1024) {
        this.deviceType = 'tablet';
        this.verticalNavType = 'collapsed';
        this.verticalEffect = 'push';
      } else if (windowWidth < 768) {
        this.deviceType = 'mobile';
        this.verticalNavType = 'offcanvas';
        this.verticalEffect = 'overlay';
      } else {
        this.deviceType = 'desktop';
        this.verticalNavType = 'expanded';
        this.verticalEffect = 'shrink';
      }
  }

  clickprofile()
  {

    this.router.navigate(['profile']);
  }

  admlogout()
  {

   // alert('click');
localStorage.setItem('isLoggedin',"0");
        localStorage.removeItem('logUser');
        localStorage.removeItem('uscentre');
        localStorage.removeItem('usid');
        localStorage.removeItem('usrl');
        this.ngOnInit();
  }
  toggleOpened() {
    if (this.windowWidth < 768) {
        this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
        this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    } else {
        this.verticalNavType = this.verticalNavType === 'expanded' ? 'collapsed' : 'expanded';
    }
  }

  toggleOpenedSidebar() {
    this.isCollapsedSideBar = this.isCollapsedSideBar === 'yes-block' ? 'no-block' : 'yes-block';
  }

  onMobileMenu() {
    this.isCollapsedMobile = this.isCollapsedMobile === 'yes-block' ? 'no-block' : 'yes-block';
  }
}



// WEBPACK FOOTER //
// D:/Angular projects/memberreg/memberreg/src/app/layouts/admin/admin-layout.component.ts